import { SchoolDTO } from './components/SearchSchoolsSelect/useSearchSchoolsSelect';

export enum EducationType {
  PrivateNonprofitFourYear,
  PublicFourYearOutOfState,
  PublicFourYearInState,
  Technical,
  Community,
  Other,
}

export interface EducationGoalData {
  educationTypeOptions: { label: string; value: EducationType }[];
  ageOptions: number[];
  name: string;
  educationType: EducationType;
  age: number;
  amount: number;
  years: number;
  isStarted: boolean;
  isSpecificCollege: boolean;
  specificCollegeName: string | null;
  specificCollegeIsPublic: boolean;
  specificCollegeIsInState: boolean;
  specificCollegeInformation: SchoolDTO | null;
}

export interface FormValues {
  isSpecificCollege: boolean;
  educationType: EducationType;
  amount: number;
  years: number;
  age: number | string | null;
  isStarted: boolean;
  specificCollegeInformation: SchoolDTO | null;
  specificCollegeIsPublic: boolean;
  specificCollegeIsInState: boolean;
  assetBucketingIndices: number[];
}

export enum CostEstimateOption {
  NationalAverage,
  SpecificCollege,
}

export enum TuitionType {
  OutOfState,
  InState,
}

export interface UpsertDTO extends Omit<FormValues, 'specificCollegeInformation'> {
  id?: string | null;
  name: string;
  specificCollegeName: string | null;
}
